import { api } from './client';
import { withTelegramId } from './session';

// ============================================================================
// Types
// ============================================================================

export interface BundlePlan {
  id: string;
  name: string;
  description: string | null;
  totalCount: number;
  regularPrice: number;
  price: number;
  validDays: number;
  earnPoints: boolean;
  imageUrl: string | null;
  status: string;
  // Stats
  soldCount: number;
  activeCount: number;
  avgUtilizationRate: number;
}

export interface BundlePass {
  id: string;
  planId: string;
  totalCount: number;
  remainingCount: number;
  status: string;
  activatedAt: string | null;
  expiresAt: string | null;
  completedAt: string | null;
  paidAmount: number;
  pointsEarned: number;
  createdAt: string;
  plan: { name: string; purchaseBarcode: string; usageBarcode: string; targetType: string };
}

export interface BundleRequestResult {
  passId: string;
  status: string;
  purchaseBarcode: string;
  planName: string;
  totalCount: number;
  paidAmount: number;
}

export interface BundleQRData {
  passId: string;
  status: string;
  barcode: string | null;
  qrType: 'purchase' | 'usage';
  planName: string;
  remainingCount: number;
  totalCount: number;
  expiresAt: string | null;
  canShowQR: boolean;
}

export interface BundleUsage {
  id: string;
  rewardName: string;
  source: string;
  createdAt: string;
}

// ============================================================================
// API Methods
// ============================================================================

// Каталог публичен; свои абонементы, покупка, QR и история — по сессии входа (K-002). telegramId — только
// необязательная сверка (мини-апп), у PWA его нет — и в запрос он не уходит.

export async function getBundlePlans(telegramId?: number | null): Promise<BundlePlan[]> {
  return api.get<BundlePlan[]>(withTelegramId('/bundles/plans', telegramId));
}

export async function getMyBundles(telegramId?: number | null): Promise<BundlePass[]> {
  return api.get<BundlePass[]>(withTelegramId('/bundles/my', telegramId));
}

export async function requestBundle(
  planId: string,
  telegramId?: number | null
): Promise<BundleRequestResult> {
  return api.post<BundleRequestResult>(withTelegramId('/bundles/request', telegramId), { planId });
}

export async function getBundleQR(
  passId: string,
  telegramId?: number | null
): Promise<BundleQRData> {
  return api.get<BundleQRData>(withTelegramId(`/bundles/${passId}/qr`, telegramId));
}

export async function getBundleHistory(
  passId: string,
  telegramId?: number | null
): Promise<BundleUsage[]> {
  return api.get<BundleUsage[]>(withTelegramId(`/bundles/${passId}/history`, telegramId));
}
